import React, { useRef } from "react";
import { LABELS } from "../../constants/labels/basicCals.labels";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import { IPRGraphData, DepletionCurveGraphData } from "../../store/model/calculations/calculation";
import DepletionCurveGraph from "../../components/calculation-section/basiccalculations/charts/depletion-curve";
import IPRCurveGraph from "../../components/calculation-section/basiccalculations/charts/wellInfo-curve";

const WellInfoPerformanceReport: React.FC = () => {
    const {
        depletionCurve,
        iprCurve,
        showIPRPlotInMainReport,
        showDepletionPlotInMainReport
    } = useAppSelector((state) => state.basicCalculations);
    const iprChartRef = useRef<HTMLDivElement | null>(null);
    const depletionChartRef = useRef<HTMLDivElement | null>(null);

    const defaultIPRData: IPRGraphData = {
        wiggins: [],
        vogel: [],
        constantPi: [],
        compositePi: [],
        x_Plot_MaxValue: 0,
        y_PlotMaxValue: 0,
        x_Plot_Interval: 0,
        y_Plot_Interval: 0,
    };

    const defaultData: DepletionCurveGraphData = {
        wiggins: [],
        depletion10Percent: [],
        depletion20Percent: [],
        depletion30Percent: [],
        depletion40Percent: [],
        depletion50Percent: [],
        depletion60Percent: [],
        depletion70Percent: [],
        generalDepletion: [],
        x_Plot_MaxValue: 0,
        y_Plot_MaxValue: 0,
        x_Plot_Interval: 0,
        y_Plot_Interval: 0,
    };

    return (
        <>
            {(showDepletionPlotInMainReport || showIPRPlotInMainReport) && <div className="determine-widget-containers">
                <div className="header-main">
                    <div className="flex flex-row justify-between">
                        <div>
                            <h3 className="text-[18px] font-semibold text-neutral-25">DETERMINE well inflow & depletion curve</h3>
                            <h5>Projected performance for the ESP design.</h5>
                        </div>
                    </div>
                </div>
                <div className="container-body border-t border-dark flex flex-col gap-2">
                    <div className="flex flex-col gap-2 pb-4 mb-4">
                        <div className="mb-[16px]" />
                        <div className="pl-[200px] pr-[200px]">
                            {showIPRPlotInMainReport && <div className="flex justify-center">
                                <div>
                                    <p className="text-[18px] font-semibold text-neutral-25 ">
                                        {LABELS?.wellInflowPerformance}
                                    </p>
                                </div>
                            </div>}
                            {/* <div className="p-[16px]"> */}
                            <div className="mb-[15px] pt-[30px]" ref={iprChartRef}>
                                {showIPRPlotInMainReport && <IPRCurveGraph data={iprCurve ? iprCurve : defaultIPRData} />}
                            </div>
                            {showDepletionPlotInMainReport && (
                                <>
                                    <div className="flex justify-center">
                                        <div>
                                            <p className="text-[18px] font-semibold text-neutral-25">
                                                {LABELS?.depletionCUrve}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="mb-[15px] pt-[30px]" ref={depletionChartRef}>
                                        <DepletionCurveGraph data={depletionCurve ?? defaultData} />
                                    </div>
                                </>
                            )}
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    );
};

export default WellInfoPerformanceReport;
